module.exports = __webpack_public_path__ + "img/home_img01.7de9f6d4.png";